"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.patch = exports.del = exports.post = exports.get = void 0;
const axios_1 = __importDefault(require("axios"));
const UrlValidator_1 = require("./UrlValidator");
const get = async ({ url, headers, data }) => {
    const validatedUrl = (0, UrlValidator_1.validateUrl)(url);
    const response = await axios_1.default.get(validatedUrl, {
        responseType: 'json',
        headers: headers,
        params: { ...data },
    });
    try {
        return response.data;
    }
    catch (e) {
        return response.data;
    }
};
exports.get = get;
const post = async ({ url, headers, data, }) => {
    const validatedUrl = (0, UrlValidator_1.validateUrl)(url);
    const response = await axios_1.default.post(validatedUrl, data, {
        responseType: 'json',
        headers: headers,
    });
    try {
        return response.data;
    }
    catch (e) {
        return response.data;
    }
};
exports.post = post;
const del = async ({ url, headers }) => {
    const validatedUrl = (0, UrlValidator_1.validateUrl)(url);
    const response = await axios_1.default.delete(validatedUrl, {
        responseType: 'json',
        headers: headers,
    });
    try {
        return response.data;
    }
    catch (e) {
        return response.data;
    }
};
exports.del = del;
const patch = async ({ url, headers, data, }) => {
    const validatedUrl = (0, UrlValidator_1.validateUrl)(url);
    const response = await axios_1.default.patch(validatedUrl, data, {
        responseType: 'json',
        headers: headers,
    });
    try {
        return response.data;
    }
    catch (e) {
        return response.data;
    }
};
exports.patch = patch;
